import { useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { ShieldCheck, Menu, X, Car, BadgeEuro, Wrench } from "lucide-react";
import { Button } from "@/components/ui/button";
import { InstallAppButton } from "@/components/InstallAppButton";

const LINKS = [["/cars", "Noleggio", Car, "nav-fleet"], ["/vendita", "Vendita", BadgeEuro, "nav-vendita"], ["/carrozzeria-pontedera", "Carrozzeria", Wrench, "nav-carrozzeria"]];

const MobileMenu = ({ onClose }) => (
  <div className="sm:hidden fixed inset-x-0 bottom-0 top-16 z-[49] bg-[#0A0B0E] p-5 flex flex-col gap-2 overflow-y-auto animate-in fade-in duration-200" data-testid="nav-mobile-menu">
    {LINKS.map(([to, label, I, id]) => (
      <Link key={to} to={to} onClick={onClose} className="flex items-center gap-3 rounded-2xl border border-white/10 bg-[#181A22] px-4 h-14 text-base font-semibold" data-testid={`${id}-mobile`}>
        <I className="w-5 h-5 text-[#E63946]" />{label}
      </Link>
    ))}
    <div className="my-2"><InstallAppButton block /></div>
    <Link to="/admin" onClick={onClose} className="flex items-center gap-3 rounded-2xl border border-white/10 px-4 h-14 text-base text-muted-foreground" data-testid="nav-admin-mobile">
      <ShieldCheck className="w-5 h-5" />Area Admin
    </Link>
  </div>
);

export const Navbar = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const onAdmin = pathname.startsWith("/admin");
  const [open, setOpen] = useState(false);
  useEffect(() => setOpen(false), [pathname]);

  return (
    <>
    <header className="fixed top-0 left-0 w-full z-50 glass border-b border-white/10" data-testid="navbar">
      <div className="max-w-7xl mx-auto px-3 sm:px-6 h-16 sm:h-28 flex items-center justify-between gap-2">
        <Link to="/" className="flex items-center group shrink-0 min-w-0" data-testid="brand-link">
          <img src="/logo-colored.png" alt="Centro Auto Pontedera" className="h-7 sm:h-16 w-auto group-hover:scale-105 transition-transform" />
        </Link>
        <nav className="flex items-center gap-1 sm:gap-4 shrink-0">
          {!onAdmin && (
            <>
              {LINKS.map(([to, label, , id]) => (
                <Link key={to} to={to} className="hidden sm:inline text-sm font-semibold text-muted-foreground hover:text-foreground transition-colors px-3" data-testid={id}>{label}</Link>
              ))}
              <Button onClick={() => navigate("/cars")} className="bg-[#E63946] hover:bg-[#D62828] text-white rounded-full px-4 sm:px-6 text-sm font-semibold" data-testid="nav-book-btn">
                <span className="sm:hidden">Prenota</span><span className="hidden sm:inline">Prenota Ora</span>
              </Button>
              <button onClick={() => setOpen(!open)} className="sm:hidden w-11 h-11 flex items-center justify-center rounded-full hover:bg-white/10" aria-label={open ? "Chiudi menu" : "Apri menu"} data-testid="nav-menu-btn">
                {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
              </button>
            </>
          )}
          <Link to="/admin" className={`${onAdmin ? "flex" : "hidden sm:flex"} w-11 h-11 items-center justify-center rounded-full text-muted-foreground hover:text-foreground hover:bg-white/10 transition-colors shrink-0`} data-testid="nav-admin" title="Area Admin" aria-label="Area Admin">
            <ShieldCheck className="w-5 h-5" />
          </Link>
        </nav>
      </div>
    </header>
    {open && !onAdmin && <MobileMenu onClose={() => setOpen(false)} />}
    </>
  );
};
